import React, { useState, useEffect, lazy, Suspense, useRef } from "react";
import Dropzone from "react-dropzone";
import axios from "axios";
/* import JSZip from "jszip"; */
/* const DropzoneLazy = lazy(() => import("react-dropzone")); */
import { SquareLoader } from "react-spinners";

const FileUploader = (props) => {
    const {
        titleDragNDropSomeFilesHereOrClickToSelectFiles,
        titleChoose,
        titleLoadMore,
        titleDeleteAll,
        titleSelect,
        titleDelete,
        serverUploadUrl, // Получение URL для загрузки из пропсов
        sessionId,
    } = props.attributes;

    const [ComponentRequestDataToRender, setComponentRequestDataToRender] =
        useState(null);
    const [ComponentUrlUploaderToRender, setComponentUrlUploaderToRender] =
        useState(null);
    const [selectedFileId, setSelectedFileId] = useState(null);
    const [selectedFileName, setSelectedFileName] = useState(null);
    const [open, setOpen] = useState(false);
    const [files, setFiles] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]); // New state for uploaded files
    const [uploadProgress, setUploadProgress] = useState({});
    const [deletedFiles, setDeletedFiles] = useState([]);
    const [isOpenModalUrlUploader, setIsOpenModalUrlUploader] = useState(false);
    const [urlUploader, setUrlUploader] = useState("");
    const [isUploading, setIsUploading] = useState({});

    const dropdownRef = useRef(null);
    const dropzoneRef = useRef(null);

    useEffect(() => {
        dropzoneRef.current.focus();
        console.log("-> " + serverUploadUrl);
    }, []);

    useEffect(() => {
        const handlePaste = (event) => {
            if (event.clipboardData && event.clipboardData.items) {
                const items = Array.from(event.clipboardData.items);
                const files = items
                    .filter((item) => item.kind === "file")
                    .map((item) => item.getAsFile());
                if (files.length > 0) {
                    onDrop(files); // Вызываем вашу функцию onDrop с файлами из буфера обмена
                }
            }
        };

        document.addEventListener("paste", handlePaste);

        return () => {
            document.removeEventListener("paste", handlePaste);
        };
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownRef]);

    useEffect(() => {
        const loadComponentRequestData = async () => {
            if (!props.componentRequestData) {
                return;
            }
            const module = await import(`./${props.componentRequestData}`);
            setComponentRequestDataToRender(() => module.default);
        };

        loadComponentRequestData();

        const loadComponentUrlUploader = async () => {
            if (!props.componentUrlUploader) {
                return;
            }
            const module = await import(`./${props.componentUrlUploader}`);
            setComponentUrlUploaderToRender(() => module.default);
        };

        loadComponentUrlUploader();
    }, [props.componentRequestData, props.componentUrlUploader]);

    const onSelect = async (fileId, fileName) => {
        if (props.componentRequestData) {
            const module = await import(`./${props.componentRequestData}`);
            setComponentRequestDataToRender(() => module.default);
            setSelectedFileId(fileId);
            setSelectedFileName(fileName);
            document.body.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    };

    const onDelete = (fileId) => {
        console.log(`Deleted file with id: ${fileId}`);
        setDeletedFiles((prevDeletedFiles) => [...prevDeletedFiles, fileId]);

        axios
            .delete(`/delete/${fileId}`)
            .then((response) => {
                props.setShowComponent(false);

                const newUploadedFiles = uploadedFiles.filter(
                    (file) => file.fileid !== fileId
                );
                setUploadedFiles(newUploadedFiles);

                props.onFilesChange(
                    newUploadedFiles.map((file) => ({
                        fileId: file.fileid,
                        fileName: file.filename,
                    }))
                );

                const nextFile = newUploadedFiles.find(
                    (file) => !deletedFiles.includes(file.fileid)
                );

                if (nextFile) {
                    if (
                        newUploadedFiles.length > 0 &&
                        nextFile.fileid !== fileId
                    ) {
                        onSelect(nextFile.fileid, nextFile.filename);
                    } else {
                        setSelectedFileId(null);
                    }
                } else {
                    setSelectedFileId(null);
                }
            })
            .catch((error) => {
                console.error(`Error deleting file with id ${fileId}:`, error);
            });
    };

    const onDeleteAllFiles = async () => {
        const allFileIds = uploadedFiles.map((file) => file.fileid);

        try {
            await axios.delete("/deleteAllFiles");
            setUploadedFiles([]);
            document.body.scrollIntoView({ behavior: "auto", block: "start" });
            window.location.reload();
        } catch (error) {
            console.error("Error deleting all files:", error);
        }
    };

    const onDrop = (acceptedFiles) => {
        const protocol =
            process.env.NODE_ENV === "development" ? "http" : "https";
        const newFiles = acceptedFiles.map((file) =>
            Object.assign(file, {
                preview: URL.createObjectURL(file),
            })
        );
        setFiles([...files, ...newFiles]);

        newFiles.forEach(async (file, index) => {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("sessionId", sessionId); // Добавление sessionId

            setIsUploading((prev) => ({ ...prev, [file.name]: true }));

            axios
                .post(
                    protocol + "://" + serverUploadUrl + "/upload" || "/upload",
                    formData,
                    {
                        onUploadProgress: (progressEvent) => {
                            setUploadProgress((prevProgress) => ({
                                ...prevProgress,
                                [file.name]:
                                    (progressEvent.loaded /
                                        progressEvent.total) *
                                    100,
                            }));
                        },
                    }
                )
                .then((res) => {
                    /* setUploadedFiles((prevFiles) => {
                        const newFiles = [...prevFiles, res.data];
                        props.onFilesChange(
                            newFiles.map((file) => ({
                                fileId: file.fileid,
                                fileName: file.filename,
                            }))
                        );
                        return newFiles;
                    }); */
                    const { files } = res.data;

                    if (files && Array.isArray(files)) {
                        // Создаем массив новых загруженных файлов
                        const newUploadedFiles = files.map((fileInfo) => ({
                            fileid: fileInfo.fileid,
                            filename: fileInfo.filename,
                        }));

                        // Обновляем состояние и вызываем onFilesChange
                        setUploadedFiles((prevFiles) => {
                            const updatedFiles = [
                                ...prevFiles,
                                ...newUploadedFiles,
                            ];

                            // Вызов onFilesChange с полным списком обновленных файлов
                            props.onFilesChange(
                                updatedFiles.map((file) => ({
                                    fileId: file.fileid,
                                    fileName: file.filename,
                                }))
                            );

                            return updatedFiles;
                        });
                    }

                    setFiles((prevFiles) =>
                        prevFiles.filter((f) => f.name !== file.name)
                    );
                    /* if (index === 0) {
                        onSelect(res.data.fileid, res.data.filename);
                    } */
                    document.body.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                    });
                    setIsUploading((prev) => ({
                        ...prev,
                        [file.name]: false,
                    }));
                })
                .catch((err) => {
                    setFiles((prevFiles) => {
                        const updatedFiles = [...prevFiles];
                        const errorFileIndex = updatedFiles.findIndex(
                            (f) => f.name === file.name
                        );
                        if (errorFileIndex !== -1) {
                            updatedFiles.splice(errorFileIndex, 1);
                        }
                        return updatedFiles;
                    });
                });
        });
    };

    const onDropClick = (event) => {
        event.stopPropagation();
        setOpen(!open);
    };

    const onOpenModalUrlUploader = () => {
        setIsOpenModalUrlUploader(!isOpenModalUrlUploader);
    };

    useEffect(() => {
        const fetchUploadedFiles = async () => {
            try {
                const response = await axios.get("/getListOfFiles");
                const fileList = response.data;

                props.onFilesChange(
                    fileList.map((file) => ({
                        fileId: file.fileid,
                        fileName: file.filename,
                    }))
                );
                setUploadedFiles(fileList);
                document.body.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            } catch (error) {
                console.error("Failed to fetch uploaded files:", error);
            }
        };

        fetchUploadedFiles();
    }, []);

    return (
        <div>
            {ComponentRequestDataToRender && (
                <ComponentRequestDataToRender
                    key={selectedFileId}
                    fileId={selectedFileId}
                    onDataChange={props.onDataChange}
                />
            )}
            {ComponentUrlUploaderToRender && (
                <ComponentUrlUploaderToRender
                    isOpenModalUrlUploader={isOpenModalUrlUploader}
                    onOpenModalUrlUploader={onOpenModalUrlUploader}
                    urlUploader={urlUploader}
                    setUrlUploader={setUrlUploader}
                />
            )}
            {props.showUploader && (
                <>
                    {uploadedFiles.length || files.length ? (
                        <div>
                            {files.map((file) => (
                                <div key={file.name}>
                                    <table className="w-full h-8">
                                        <tbody>
                                            <tr>
                                                <td className="border w-1/2 px-10 py-2 rounded-l">
                                                    {file.name}
                                                </td>
                                                {uploadProgress[file.name] !==
                                                    undefined &&
                                                uploadProgress[file.name] !==
                                                    100 ? (
                                                    <td
                                                        className="border w-1/2 px-10 py-2 overflow-hidden"
                                                        style={{
                                                            maxWidth: "150px",
                                                            textOverflow:
                                                                "ellipsis",
                                                            whiteSpace:
                                                                "nowrap",
                                                        }}
                                                    >
                                                        <div className="progress-container">
                                                            <div
                                                                className="progress-bar"
                                                                style={{
                                                                    width: `${
                                                                        uploadProgress[
                                                                            file
                                                                                .name
                                                                        ] || 0
                                                                    }%`,
                                                                }}
                                                            ></div>
                                                            <div className="progress-text">
                                                                {`${
                                                                    Math.round(
                                                                        uploadProgress[
                                                                            file
                                                                                .name
                                                                        ]
                                                                    ) || 0
                                                                }%`}
                                                            </div>
                                                        </div>
                                                    </td>
                                                ) : (
                                                    isUploading[file.name] && (
                                                        <td className="border w-1/2 px-10 py-2 flex justify-center items-center">
                                                            <SquareLoader
                                                                color={
                                                                    "#36d7b7"
                                                                }
                                                                size={24}
                                                            />
                                                        </td>
                                                    )
                                                )}
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            ))}
                            {uploadedFiles
                                .filter(
                                    (file) =>
                                        !deletedFiles.includes(file.fileid)
                                )
                                .map((file) => (
                                    <table
                                        key={file.fileid}
                                        className="w-full h-8 mt-4"
                                    >
                                        <tbody>
                                            <tr>
                                                <td className="border w-1/3 px-10 py-2 rounded-l">
                                                    {file.fileid}
                                                </td>
                                                <td
                                                    className="border w-1/3 px-10 py-2 overflow-hidden"
                                                    style={{
                                                        maxWidth: "150px",
                                                        textOverflow:
                                                            "ellipsis",
                                                        whiteSpace: "nowrap",
                                                    }}
                                                >
                                                    {file.filename}
                                                </td>
                                                <td className="border px-6 py-3 flex">
                                                    <button
                                                        key={
                                                            "delete-" +
                                                            file.fileid
                                                        }
                                                        onClick={() =>
                                                            onDelete(
                                                                file.fileid
                                                            )
                                                        }
                                                        className="bg-red-500 text-white px-3 py-2 rounded focus:outline-none"
                                                        title="Delete"
                                                    >
                                                        <span>&#10006;</span>{" "}
                                                        <span className="mobile-hide">
                                                            {titleDelete}
                                                        </span>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                ))}

                            <div className="flex justify-center mt-4 mb-2">
                                <button
                                    onClick={() => onDeleteAllFiles()}
                                    className="ml-2 bg-red-500 text-white px-6 py-3 rounded shadow-sm text-sm"
                                >
                                    {titleDeleteAll}
                                </button>
                            </div>
                        </div>
                    ) : null}

                    <Suspense fallback={<div>Loading...</div>}>
                        <Dropzone onDrop={onDrop}>
                            {({ getRootProps, getInputProps }) => (
                                <section
                                    {...getRootProps()}
                                    ref={dropzoneRef}
                                    className="w-full p-2  h-96 border-4 border-dashed rounded-lg flex flex-col items-center justify-center cursor-pointer"
                                    style={{
                                        borderColor: "#4e7792",
                                        backgroundColor: "#e9eef1",
                                        boxShadow:
                                            "inset 5px 5px 10px #1b3a50, inset -5px -5px 10px #297091",
                                    }}
                                >
                                    <input {...getInputProps()} />
                                    <p>
                                        {
                                            titleDragNDropSomeFilesHereOrClickToSelectFiles
                                        }
                                    </p>
                                    <div className="mt-2 flex">
                                        <button className="bg-blue-500 text-white px-6 py-3 rounded-l shadow-sm text-sm">
                                            {titleChoose}
                                        </button>
                                    </div>
                                </section>
                            )}
                        </Dropzone>
                    </Suspense>
                </>
            )}
        </div>
    );
};

export default FileUploader;
